import {
  Grid,
  Pagination,
  PaginationItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { createStyles, Theme, makeStyles } from "@material-ui/core";
import { ColumnModel } from "../../models/common.model";
import { useHistory } from "react-router-dom";
import { PaginationInfo } from "../../models/loan.model";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) =>
  createStyles({
    select: {
      "&.Mui-selected": {
        backgroundColor: muiSelected,
      },
    },
  })
);
let muiSelected: any;
const columns: readonly ColumnModel[] = [];
interface props {
  columns: any;
  data: any;
  pageInfo: any;
  handleChangePagination: any;
}
export default function TableCreator({
  columns,
  data,
  pageInfo,
  handleChangePagination,
  currentPaginationInfo,
  pathname,
}: any) {
  const history = useHistory<{
    from: string;
    id: string;
    pageNumber: 1;
    clickOnBack: boolean;
  }>();

  const handelDetail = (
    requestId: string,
    loanRequestStatus: string,
    registrationRequestId: number,
    rowIndex: number
  ) => {
    // handleSelectRow(rowIndex);
    history.push({
      pathname: pathname,
      state: {
        id: requestId,
        from: "",
        // pageNumber: currentPaginationInfo.pageNumber!,
        pageNumber: 1,
        clickOnBack: false,
      },
    });
  };
  const classes = useStyles();
  const nextIcon = () => {
    return (
      <img style={{ height: "12px", width: "10px" }} src="images/Next.png" />
    );
  };
  const previusIcon = () => {
    return (
      <img
        style={{ height: "12px", width: "10px" }}
        src="images/Previous.png"
      />
    );
  };
  const jsonFile = useSelector((state: any) => state.style);
  muiSelected = jsonFile?.muiSelected;
  return (
    <div>
      <div className="cardTableBorder ">
        <TableContainer
          style={{ background: "#fff", direction: "rtl" }}
          // className="boxScroll"
        >
          <Table
            stickyHeader
            aria-label="sticky table "
            style={{ borderCollapse: "collapse" }}
          >
            <TableHead className="rowTHead" style={{ paddingBottom: "10px" }}>
              <TableRow
                classes={{ root: classes.select }}
                className={`${classes} borderRight borderLeft`}
                // selected={selectedRow === 0}
              >
                <TableCell
                  className="rowTHead colorTitle textFont12 fontWeight"
                  align="right"
                  style={{ width: "5px" }}
                >
                  #
                </TableCell>
                {columns.map((column: any) => (
                  <TableCell
                    className="rowTHead colorTitle textFont12 fontWeight nowrapClass"
                    key={column.id}
                    align="right"
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <div style={{ width: "100%", height: "10px" }}></div>
            <TableBody>
              {data?.map((row: any, rowIndex: number) => {
                return (
                  <TableRow
                    classes={{ root: classes.select }}
                    className={`${
                      rowIndex % 2 == 0
                        ? "rowTBodyE  borderRight borderLeft"
                        : "rowTBodyO  borderRight borderLeft"
                    }${classes} borderRight borderLeft  noWrap`}
                    hover
                    role="checkbox"
                    tabIndex={-1}
                    key={row.loanRequestId}
                    // selected={selectedRow === rowIndex}
                    onClick={() =>
                      handelDetail(
                        row.referenceKey,
                        row.loanRequestStatus,
                        row.registrationRequestId,
                        rowIndex
                      )
                    }
                  >
                    <TableCell className="textFont12" style={{ width: "5px" }}>
                      {(0 - 1) * 0 + rowIndex + 1}
                    </TableCell>
                    {columns.map((column: any) => {
                      const value = row[column.id as keyof any];
                      return (
                        <TableCell
                          className="textFont12 nowrapClass"
                          key={column.id}
                          align="right"
                        >
                          {column.format && column.hasFormat
                            ? column.format(value)
                            : value}
                          {/* <span
                            className={
                              "badge " +
                              (row.loanRequestStatusColor
                                ? row.loanRequestStatusColor === "GreenLable"
                                  ? "badge-success"
                                  : "badge-danger"
                                : "badge-light")
                            }
                          >
                            {value}
                          </span> */}
                        </TableCell>
                      );
                    })}
                    {/* <TableCell className="textFont12" align="right">
                      <span
                        className={
                          "badge " +
                          (row.loanRequestStatusColor
                            ? row.loanRequestStatusColor === "GreenLable"
                              ? "badge-success"
                              : "badge-danger"
                            : "badge-light")
                        }
                      >
                        {row.loanRequestStatusTitle}
                      </span>
                    </TableCell>
                    <TableCell className="textFont12" align="right">
                      <span
                        className={
                          "badge " +
                          (row.supplierSettlementStatusColor
                            ? row.supplierSettlementStatusColor === "GreenLable"
                              ? "badge-success"
                              : "badge-danger"
                            : "badge-light")
                        }
                      >
                        {row.supplierSettlementStatusTitle}
                      </span>
                    </TableCell> */}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      {/* <div>
        <Grid container spacing={2} alignItems="center">
          <Grid
            item
            xs={12}
            sm={4}
            display="flex"
            justifyContent={{ xs: "center", sm: "flex-start" }}
          >
            <span
              style={{ color: "#1D4A87", top: "1vh", position: "relative" }}
            >
              تعداد کل :
              <span style={{ color: "#01AF43" }}>{pageInfo.total}</span> مورد
            </span>
          </Grid>
          <Grid item xs={12} sm={4} display="flex" justifyContent="center">
            <Pagination
              renderItem={(item) => (
                <PaginationItem
                  components={{
                    previous: previusIcon,
                    next: nextIcon,
                  }}
                  {...item}
                />
              )}
              // color="primary"
              sx={{
                direction: "ltr",
                margin: "5px",
                button: {
                  color: "#25D1C9",
                  fontSize: "14px !important",
                  fontFamily: "iranSans",
                },
              }}
              count={
                pageInfo ? Math.ceil(pageInfo.total / pageInfo.pageSize) : 0
              }
              onChange={handleChangePagination}
              page={currentPaginationInfo.pageNumber}
            />
          </Grid>
          <Grid item xs={12} sm={4}></Grid>
        </Grid>
      </div> */}
    </div>
  );
}
